export const newWorkspaceAdapter = newWorkspace => ({
  id: newWorkspace.id,
  name: newWorkspace.name,
  description: newWorkspace.description,
  rootFolder: newWorkspace.root_folder,
  apiKey: newWorkspace.api_key
})
